import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ImagilityBaseResponse } from 'app-models';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { take, takeUntil } from 'rxjs/operators';
import { AttorneySendInviteDialogLibraryService } from './attorney-send-invite-dialog-library.service';
import { Subject } from 'rxjs';
import { UserIdValidationLibraryService } from 'user-id-validation-library';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'lib-attorney-send-invite-dialog-library',
  templateUrl: './attorney-send-invite-dialog-library.component.html',
  styleUrls: ['./attorney-send-invite-dialog-library.component.scss']
})
export class AttorneySendInviteDialogLibraryComponent implements OnDestroy, AfterViewInit {
  sendInviteForm: FormGroup;
  userIdValid: boolean;
  userType: string;
  globalError:string = 'Something went wrong please try again later';
  observableSubscription$ = new Subject();
  autoGeneratedId : boolean = false;
  @ViewChild('popover', { static: false }) popover: ElementRef;
  
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private confirmationServicePopup: ConfirmationService,
    private attorneySendInviteDialogLibraryService: AttorneySendInviteDialogLibraryService,
    private toastService: ToastrService,
    private userIdValidationLibraryService: UserIdValidationLibraryService
  ) {
    this.sendInviteForm = new FormGroup({
      companyName: new FormControl(this.config.data.companyName),
      beneficiaryId: new FormControl(config.data.beneficiaryId),
      emailId: new FormControl(config.data.emailId),
      name: new FormControl(config.data.name),
      userId: new FormControl(null, Validators.required)
    });
    this.userType = sessionStorage.getItem("userTypeRole"); 
  }

  ngAfterViewInit(): void {
    if(this.config && this.config.data.name){
      this.generateUniqueUsername(this.popover);
    }
  }
  onSubmit() {
    this.confirmationServicePopup.confirm({
      message: 'Are you sure you want to send invite?',
      header: 'Send Invite',
      accept: () => {  
        if (this.userType === "Petitioner") {  
          this.inviteFromPetitioner(this.sendInviteForm.get('beneficiaryId').value, this.config.data.companyId);
        } else {  
          this.inviteFromAttorney();
        }
      },
      reject: () => {
        this.ref.close();
      }
    });
  } 

  inviteFromPetitioner(beneficiaryEmployeeId, companyId) {
    this.attorneySendInviteDialogLibraryService.checkIsInvited(beneficiaryEmployeeId, companyId)
      .pipe(take(1))
      .subscribe(result => {      
        if (result.status === 200 && result.data.hasAccount) {
          this.toastService.info(result.message);  
        } 
        else if (result.status === 200 && !result.data.hasAccount) {
          this.inviteFromAttorney(); 
        }
        else if (result.status === 202 && String(result.message).endsWith('Do you want to Invite again?')) {  
          this.confirmationServicePopup.confirm({
            message: result.message,
            header: 'Send Invite',
            accept: () => {
              this.attorneySendInviteDialogLibraryService.sendInviteToAttorneyforcetoupdate(beneficiaryEmployeeId, companyId)
                .pipe(take(1))
                .subscribe(result => { 
                  if (result.status === 200 && result.message === 'Petitioner Invited Beneficiary Successfully.') {
                    this.inviteFromAttorney();
                  }else{
                    CustomErrorToastComponent.showErrorToast(this.toastService, this.globalError);
                  }
                });
            },
            reject: () => { }
          });
        }
        else{
          CustomErrorToastComponent.showErrorToast(this.toastService, this.globalError);
        }
        this.ref.close();
      });
  }
 
  inviteFromAttorney() {
    this.attorneySendInviteDialogLibraryService.sendInviteToAttorneyCreatedEmpBene(this.config.data.companyId, {
      beneficiaryId: this.config.data.beneficiaryId,
      emailId: this.config.data.emailId,
      userId: this.sendInviteForm.get('userId').value
    })
      .pipe(take(1))
      .subscribe((result: ImagilityBaseResponse) => {
        if (result.status === 200) {
          this.toastService.success(result.message, 'Success');
        } else if (result.status === 202) {
          this.toastService.info(result.message);
        }
        this.ref.close();
      });
  }

  setUserIdValidity(flag) {
    this.userIdValid = flag;
    if (!this.sendInviteForm.get('userId').getError('required')) {
      if (flag) {
        this.sendInviteForm.get('userId').setErrors(null);
      } else {
        this.sendInviteForm.get('userId').setErrors({ mustMatch: true });
      }
    }
  }

  generateUniqueUsername(popover){
    let fullNameArray: any[] = [];
    if(this.config && this.config.data.name){
      fullNameArray = this.config.data.name.split(' ').filter((el)=>  el);
    }

    if((this.sendInviteForm.get('userId').value && this.userIdValid)) return;

    const userId = this.attorneySendInviteDialogLibraryService.getUserName(fullNameArray);

    this.userIdValidationLibraryService.checkUserIdAvailability(userId).pipe(takeUntil(this.observableSubscription$)).subscribe((response)=> {
      if(response && response.status === 200){
        if(response.data.available){
          this.autoGeneratedId = true;
          this.sendInviteForm.get('userId').setValue(userId);
          this.sendInviteForm.get('userId').markAsDirty();
          this.sendInviteForm.get('userId').updateValueAndValidity();
          this.setUserIdValidity(true);
          setTimeout(() => {
            if(popover){
              popover.open();
            }
          }, 500);
          
        }else{
          this.generateUniqueUsername(popover);
        }
      }
    })
  }

  onChangeUserId(){
    this.autoGeneratedId = false;
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
